import { makeStyles } from '@material-ui/styles';

export default makeStyles((theme) => ({
  textField: {
    margin: 10,
  },
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
  spaceIconText: {
    marginLeft: 4,
  },
  headerAccordion: {
    display: 'flex',
    alignItems: 'center',
  },
}));
